// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__uGp-T","card":"DashboardPage_card__D-pxW","panelMobile":"DashboardPage_panelMobile__KC-2d"};